import React, { useState, useEffect, useCallback, useRef } from 'react'
import { Link } from 'react-router-dom'
import SOWSubscriptionFilter from './SOWSubscriptionFilter'
import { TableInstance, Table } from '../table'
import { useErrorService } from '@abroad/components'
import API from '../../utils/API'
import { formatDate } from '../../utils/date'
// import { formatDateInPlan } from '../../utils/date'

import labels from '../../constants/labels'
const UserSOWSubscription = () => {
  const initialState = {
    sowStatus: '',
    coachName: '',
    // preDate: '',
    // postDate: '',
  }
  const Error = useErrorService()

  const hasMore = useRef(false)
  const [sowData, setSowData] = useState([])
  const [reqData, setReqData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [coachList, setCoachList] = useState([])

  const getPaymentInfo = useCallback(async () => {
    if (reqData.page === 1) {
      setSowData([])
    }
    setLoading(true)
    try {
      const { data } = await API.AdminAPI.payment.getSubscriptionPayment(
        reqData,
      )
      if (data.length === 0 || data.length < 25) {
        hasMore.current = false
      } else {
        hasMore.current = true
      }
      if (reqData.page > 1) {
        setSowData((prev) => [...prev, ...data])
      } else {
        setSowData(data)
      }
      setLoading(false)
    } catch (e) {
      Error.showError(e)
      setLoading(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reqData])

  useEffect(() => {
    if (reqData) {
      getPaymentInfo(reqData)
    }
  }, [getPaymentInfo, reqData])

  useEffect(() => {
    const getCoachList = async () => {
      try {
        let { data } = await API.AdminAPI.userList.getCoaches()
        setCoachList((prev) => [...prev, ...data])
        // setLoading(false)
      } catch (e) {
        Error.showError(e)
        // setLoading(false)
      }
    }
    getCoachList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const fetchData = useCallback(
    ({
      sowStatus,
      coachName,
      page,
      limit,
      // preDate, postDate
    }) => {
      const selectedCoach = coachList.find(
        (coach) => coach.fullName === coachName,
      )
      const coachId = selectedCoach ? selectedCoach.id : ''

      const req = {
        limit,
        page,
        filter: {
          // ...((preDate || postDate) && {
          //   createdAt: {
          //     preDate: formatDateInPlan(preDate),
          //     postDate: formatDateInPlan(postDate),
          //   },
          // }),
          ...(sowStatus && { sowStatus }),
          ...(coachId && { coachId }),
        },
      }
      setReqData(req)
    },
    [coachList],
  )

  const sowStatus = labels?.sowStatusLabel

  const renderSOWStatusLabel = (status) => {
    if (status === sowStatus[3].value) {
      return 'Payment Issues(Failed)'
    }
    if (status === sowStatus[0].value) {
      return 'To be sent for payment to the client(Draft)'
    }
    return sowStatus.find((item) => item.value === status)?.label || status
  }
  const columns = React.useMemo(
    () => [
      {
        id: 'clientName',
        Header: 'Client Name',
        width: '20%',
        accessor: (properties) => properties?.clientId?.fullName,
        disableSortBy: true,
      },
      {
        id: 'planName',
        Header: 'Plan Name',
        width: '30%',
        accessor: 'planName',
        Cell: ({ row }) => {
          const { planName, clientId, id, _id } = row.original
          const sowId = id || _id
          return (
            <div>
              <Link
                to={`/coach/clients/${clientId?._id}/plans/${sowId}`}
                target='_blank'
                className='word-breakall'>
                {planName}
              </Link>
            </div>
          )
        },
        disableSortBy: true,
      },
      {
        id: 'createdAt',
        Header: 'Creation Date',
        accessor: 'createdAt',
        width: '15%',
        Cell: ({ value }) => <span>{formatDate(value)}</span>,
        disableSortBy: true,
      },
      {
        id: 'sowStatus',
        Header: 'SOW Status',
        accessor: 'sowStatus',
        width: '22%',
        Cell: ({ value }) => <span>{renderSOWStatusLabel(value)}</span>,

        disableSortBy: true,
      },
      {
        id: 'coachName',
        Header: 'Coach Name',
        width: '13%',

        accessor: (properties) => properties?.coachId?.fullName,
        disableSortBy: true,
      },
    ],
    [],
  )

  return (
    <>
      <TableInstance
        data={sowData}
        columns={columns}
        initialState={{
          globalFilter: initialState,
        }}>
        {({
          preGlobalFilteredRows,
          state: { globalFilter, ...other },
          setGlobalFilter,
          ...rest
        }) => (
          <div>
            <div className='mt-3'>
              <SOWSubscriptionFilter
                globalFilter={globalFilter}
                setGlobalFilter={setGlobalFilter}
                handleClearFilter={() => setGlobalFilter(initialState)}
                isLoading={loading}
                coachList={coachList}
              />
            </div>

            <Table
              ref={hasMore}
              emptyTableMessage={`No user payment found.`}
              tableInstance={{
                preGlobalFilteredRows,
                state: { globalFilter, ...other },
                setGlobalFilter,
                ...rest,
              }}
              isLoading={loading}
              fetchData={fetchData}
              totalNumberOfColumns='6'
            />
          </div>
        )}
      </TableInstance>
    </>
  )
}

export default UserSOWSubscription
